var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityAudioDescription = function SvgAccessibilityAudioDescription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M15.017 12.348a2.66 2.66 0 0 1 0 5.32h-.546v-5.32z"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    d: "M15.292 19.995c2.755 0 4.697-2.238 4.697-4.989a4.977 4.977 0 0 0-4.957-4.997h-2.808v9.989h2.766"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M8.172 10.007 1 20h2.763l.84-1.322H8.27V20h2.189v-9.993z"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M8.277 16.596H5.98l2.303-3.573z"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    d: "M21.332 19.961A8.03 8.03 0 0 0 20.925 10m3.425 9.961A8.034 8.034 0 0 0 23.948 10m3.426 9.961A8.034 8.034 0 0 0 26.97 10"
  }))));
};
export default SvgAccessibilityAudioDescription;